"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OTP = void 0;
var _react = _interopRequireWildcard(require("react"));
var _OTP = require("./OTP.styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var OTP = function OTP(_ref) {
  var numberOfDigits = _ref.numberOfDigits,
    onOTPChange = _ref.onOTPChange;
  var classes = (0, _OTP.useStyles)();
  var _useState = (0, _react.useState)(new Array(numberOfDigits).fill('')),
    _useState2 = _slicedToArray(_useState, 2),
    otp = _useState2[0],
    setOtp = _useState2[1];
  var otpBoxReference = (0, _react.useRef)([]);
  (0, _react.useEffect)(function () {
    if (otpBoxReference.current[0]) {
      // @ts-ignore
      otpBoxReference.current[0].focus();
    }
  }, []);
  var handleChange = function handleChange(value, index) {
    var newArr = _toConsumableArray(otp);
    newArr[index] = value;
    setOtp(newArr);
    onOTPChange(newArr.join('')); // Pass OTP back
    if (value && index < numberOfDigits - 1) {
      // @ts-ignore
      otpBoxReference.current[index + 1].focus();
    }
  };
  var handleBackspaceAndEnter = function handleBackspaceAndEnter(e, index) {
    if (e.key === 'Backspace' && !e.target.value && index > 0) {
      // @ts-ignore
      otpBoxReference.current[index - 1].focus();
      var newArr = _toConsumableArray(otp);
      newArr[index - 1] = '';
      setOtp(newArr);
      onOTPChange(newArr.join(''));
    }
    if (e.key === 'Enter' && e.target.value && index < numberOfDigits - 1) {
      // @ts-ignore
      otpBoxReference.current[index + 1].focus();
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.optContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.optInput
  }, otp.map(function (digit, index) {
    return /*#__PURE__*/_react["default"].createElement("input", {
      key: index,
      value: digit,
      maxLength: 1,
      onChange: function onChange(e) {
        return handleChange(e.target.value, index);
      },
      onKeyUp: function onKeyUp(e) {
        return handleBackspaceAndEnter(e, index);
      }
      // @ts-ignore
      ,
      ref: function ref(reference) {
        return otpBoxReference.current[index] = reference;
      },
      className: classes.otpInputs,
      "data-test-id": "otp-input-".concat(index)
    });
  })));
};
exports.OTP = OTP;